import DifferentHours from 'components/shared/DifferentHours'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { DropdownLabel } from './styles'
import { OpeningHoursDto } from 'store/api-slice/hooks'
import { scrollModalToTop } from 'helpers/animateScroll'
import Box from 'components/shared/Box'

interface SectionProps {
    season: OpeningHoursDto
    isOpened: boolean
    setOpenedTabIndex: (index: string | null) => void
    id: string
}

const MobileComponent = ({
    season,
    isOpened,
    setOpenedTabIndex,
    id,
}: SectionProps) => {
    const { title } = season

    const handleClick = () => {
        if (isOpened) {
            setOpenedTabIndex(null)
        } else {
            setOpenedTabIndex(id)
            scrollModalToTop()
        }
    }
    return (
        <Box isFullWidth={true}>
            <DropdownLabel
                onClick={() => handleClick()}
                direction="row"
                justify="space-between"
                align="center"
                isFullWidth={true}
                padding={16}
                mb={isOpened ? [46, 24] : 0}
                id={id}
            >
                <Text variant="bodyStrong" color="grayscale_900">
                    {title}
                </Text>
                <Icon
                    variant="chevron"
                    rotation={isOpened ? 180 : 0}
                    color="primary_500"
                />
            </DropdownLabel>
            <DifferentHours season={season} isClosed={!isOpened} />
        </Box>
    )
}

export default MobileComponent
